/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useState} from 'react'
import {Dropdown, FormControl} from 'react-bootstrap'

type HSDropdownProps = {
  items: Array<{data: string}>
  value?: string
  onSelect: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

const HSDropdown: FC<HSDropdownProps> = ({
  items,
  value,
  onSelect,
  placeholder = 'Select...',
  disabled = false,
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [selectedValue, setSelectedValue] = useState<string | undefined>(value)
  const [filteredItems, setFilteredItems] = useState<Array<{data: string}>>([])

  useEffect(() => {
    setFilteredItems(items ?? [])
  }, [items])

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const term = event.target.value
    setSearchTerm(term)
    const filtered = items?.filter((item) =>
      String(item.data).toLowerCase().includes(term.toLowerCase())
    )
    setFilteredItems(filtered ?? [])
  }

  const removeSearchTerm = () => {
    setSearchTerm('')
    setFilteredItems(items ?? [])
  }

  const handleSelect = (item: {data: string}) => {
    onSelect(String(item.data))
    setSelectedValue(String(item.data))
  }

  const dropdownItem = filteredItems?.map((item, index) => {
    return (
      <Dropdown.Item
        key={`${item.data}-${index}`}
        role='menuitem'
        size='sm'
        onClick={() => handleSelect(item)}
        title={String(item.data)}
      >
        {String(item.data)}
      </Dropdown.Item>
    )
  })

  return (
    <Dropdown onToggle={removeSearchTerm}>
      <Dropdown.Toggle
        variant='label-dropdown'
        id=''
        className='btn btn-sm btn-bold dropdown-toggle fw-normal text-start w-100'
        style={{
          display: 'flex',
          height: '3.4rem',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        disabled={disabled}
      >
        {selectedValue ? (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'clip',
              maxWidth: '200px',
            }}
          >
            {selectedValue}
          </div>
        ) : (
          placeholder
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu className='dropdown-econ-menu w-100'>
        <FormControl
          type='text'
          size='sm'
          placeholder='Search...'
          className='dropdown-econ-search-bar'
          value={searchTerm}
          onChange={handleSearch}
          style={{}}
        />
        {dropdownItem}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default HSDropdown
